import ServiceBubble from "../General/ServiceBubble/ServiceBubble";

import SectionTitle from "../General/SectionTitle";
import Features1 from "./Feature1/Features1";
import Features2 from "./Feature2/Features2";
import Features4 from "./Feature4/Features4";
import { CarouselHolder, FeaturesContainer } from "./Features.styles";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLocale } from "../../../locales/localeSlice";

const AmazingFeatures = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  const featuresArray = [Features1, Features2, Features4];

  return (
    <FeaturesContainer>
      <ServiceBubble
        position="center"
        label={t("servicesSection.keyFeatures", { lng: currentLocale })}
        backgroundColor="rgba(0, 199, 3, 0.1)"
      />
      <SectionTitle
        label={t("amazingFeatures.title", { lng: currentLocale })}
      />
      <CarouselHolder>
        {featuresArray.map((Component, index) => (
          <Component key={index} />
        ))}
      </CarouselHolder>
    </FeaturesContainer>
  );
};

export default AmazingFeatures;
